import { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { fetchContactDescription } from '../../api/contacts/fetchContactDescription';
import { fetchContacts } from '../../api/contacts/fetchContacts';
import NotFound from '../../app/[locale]/(digitalHub)/not-found';
import { ContactInfoUser, DigitalhubDivider } from '../../components';
import { useBreakpoint, useInitialize } from '../../hooks';
import { Column, HeadlineSmall, TitleMedium } from '../../styles';
import { Contact, User } from '../../types';
import { Container, LeftContainer, RightContainer } from './styles';

const ContactScreen = () => {
    const [contactPersons, setContactPersons] = useState<Contact[]>([]);
    const [contactDescription, setContactDescription] = useState<string | null>(null);
    const [hasError, setHasError] = useState<boolean>(false);

    const breakpoint = useBreakpoint();

    useInitialize(() => {
        fetchContacts()
            .then((response) => {
                setContactPersons(response.contacts);
                setHasError(response.error !== undefined);
            })
            .catch(console.error);
        fetchContactDescription().then((response) => {
            setContactDescription(response.contactDescription);
            setHasError(response.error !== undefined);
        });
    });

    if (hasError) return <NotFound />;

    return (
        <Container viewSize={breakpoint}>
            <LeftContainer viewSize={breakpoint}>
                <HeadlineSmall color='primary'>Unser Team</HeadlineSmall>
                {contactDescription && (
                    <ReactMarkdown>{contactDescription.replaceAll('\n', '  \n ')}</ReactMarkdown>
                )}
            </LeftContainer>
            <DigitalhubDivider orientation='vertical' />
            <RightContainer viewSize={breakpoint}>
                <Column>
                    <TitleMedium>Ihre Ansprechpersonen</TitleMedium>
                    <Column gap={2} mt={2}>
                        {contactPersons.map((contact) => (
                            <ContactInfoUser
                                key={contact.id}
                                user={contact as Partial<User>}
                                personal={false}
                            />
                        ))}
                    </Column>
                </Column>
            </RightContainer>
        </Container>
    );
};

export default ContactScreen;
